import moment from 'moment'
import { getAPIUrl } from '../API'

const isValidPayload = (values: GetLogFromTrackingNumberProps) => {
  if (Object.values(values).some((value) => !value)) return false
  return true
}

export interface GetLogFromTrackingNumberProps {
  deedsOfficeCode?: string
  trackingNo?: number
  reference?: string
  address?: string
}

export interface DotsTrackingStatusResponse {
  scannedDate: string
  trackingStatus: string
}
export type GetLogFromTrackingNumberResponse = DotsTrackingStatusResponse[]

export const getLogFromTrackingNumber = async (
  values: GetLogFromTrackingNumberProps,
) => {
  const valid = isValidPayload(values)
  if (!valid) throw new Error('Invalid payload')
  const result = await fetch(
    getAPIUrl() + `/Deeds/DotsPropertyTrackingDetails`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
      },
      body: JSON.stringify(values),
    },
  )

  if (result.ok) {
    const data = await result.json()
    return data.data.dotsTrackingStatusResponses
  }

  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map((item) => ({
    status: 'LODGEMENT',
    date: moment().add(item, 'days').format('YYYY-MM-DD hh:mm:ss'),
  }))
}
